import {Environment} from "./environment.type";

// for dev purpose only
export const environment: Environment = {
    production: false,

    isChina: false,
    // dynamically loaded
    IDENTITY_PROVIDER: null,
    keycloak: {},
    aws: {},
    apiUrl: null,
    //----------------------

    appName: 'WESETH',
    captchaKey: '6Ldnr0EdAAAAAPoOZD0xQs0xIUMKlhHZDEC4xnQl',
    googleApiKey: 'AIzaSyA6F9LbJG5qoVbQMkAEQ_zDCcz_l9QMJ-w',

    appVersion: require('./version.json').version

};
